module.exports = __webpack_public_path__ + "assets/img/index-leftmenu-bg.fce8eb52.png";